import { NonAuTermsModal } from '@/app-shell/non-au-terms-modal';
import { useQuerySpecialtyTranscript } from '@/hooks/query/useQuerySpecialtyTranscript';
// migration-allow(family-importers): the community details host resolves the specialty label for the moved header
import { useSpecialtyDisplayName } from '@/hooks/useSpecialtyDisplayName';
import {
  DetailsHeader,
  TemplateFormPreviewSection,
  TemplateXmlFormPreviewSection,
} from '@heidi/templates';
import { type ComponentProps } from 'react';

export const TemplateXmlFormPreviewSectionHost = (
  props: Omit<
    ComponentProps<typeof TemplateXmlFormPreviewSection>,
    'useSpecialtyTranscript' | 'TermsModal'
  >
) => (
  <TemplateXmlFormPreviewSection
    {...props}
    useSpecialtyTranscript={useQuerySpecialtyTranscript}
    TermsModal={NonAuTermsModal}
  />
);

export const DetailsHeaderHost = (
  props: Omit<ComponentProps<typeof DetailsHeader>, 'getSpecialtyDisplayName'>
) => {
  const getSpecialtyDisplayName = useSpecialtyDisplayName();
  return <DetailsHeader {...props} getSpecialtyDisplayName={getSpecialtyDisplayName} />;
};

export const TemplateFormPreviewSectionHost = (
  props: Omit<
    ComponentProps<typeof TemplateFormPreviewSection>,
    'useSpecialtyTranscript' | 'TermsModal'
  >
) => (
  <TemplateFormPreviewSection
    {...props}
    useSpecialtyTranscript={useQuerySpecialtyTranscript}
    TermsModal={NonAuTermsModal}
  />
);
